module.exports = __webpack_public_path__ + "img/cotton.5480649f.png";